import { notifyOnError } from '~/rage/decorators';
import { BackendService } from '../BackendService';
import { INotificationsService } from '../NotificationsService';
import { RpcService } from '../RpcService';
import { IFeedbackService } from './feedbackServiceTypes';

export class FeedbackService implements IFeedbackService {
	constructor(
		private readonly backend: BackendService,
		private readonly rpc: RpcService,
		private readonly notifications: INotificationsService,
	) {}

	@notifyOnError
	public async sendFeedback(title: string, message: string): Promise<void> {
		await this.backend.invoke('feedback:send', { title, message });
		this.notifications.showSuccess(
			'Сообщение получено! Спасибо, что помогаете проекту становиться лучше',
		);
	}

	@notifyOnError
	public async close(): Promise<void> {
		await this.rpc.invokeClient('feedback:close');
	}
}
